/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobAdGenerationContentTranslation } from './job-ad-generation-content-translation';

export interface JobAdGenerationContentItem {
  id?: string;
  order?: number;
  kind?: JobAdGenerationContentItemKindEnum;
  elementKind?: JobAdGenerationContentItemElementKindEnum | null;
  agentEditPolicy?: JobAdGenerationContentItemAgentEditPolicyEnum | null;
  agentInstruction?: string | null;
  body?: string | null;
  imageUrl?: string | null;
  staticBuildingBlockId?: string | null;
  sourceTemplateItemId?: string | null;
  translations?: Array<JobAdGenerationContentTranslation> | null;
  items?: Array<JobAdGenerationContentItem> | null;
}
export enum JobAdGenerationContentItemKindEnum {
  Section = 'Section',
  Html = 'Html',
  Element = 'Element',
  StaticBuildingBlock = 'StaticBuildingBlock',
  Benchmark = 'Benchmark',
  Title = 'Title'
}
export enum JobAdGenerationContentItemElementKindEnum {
  Spacer = 'Spacer',
  Line = 'Line',
  PageBreak = 'PageBreak'
}
export enum JobAdGenerationContentItemAgentEditPolicyEnum {
  Editable = 'Editable',
  Locked = 'Locked',
  Required = 'Required'
}
